import { useEffect, useRef } from 'react'

import { returnProtectionProductPrice } from '@/configuration/pages/ConfigurationPage/ReturnProtectionConfiguration/ReturnProtectionAppearanceConfiguration/constants'

import { previewUpdateDelay } from './constants'
import { replacePreview } from './helpers'

const useWidgetPreview = ({ view, settings, currency, locale }) => {
  const containerRef = useRef(null)
  const previewRef = useRef({ unmount: null })

  const serializedSettings = JSON.stringify(settings)

  useEffect(() => {
    const preview = previewRef.current
    const config = {
      preview: true,
      view,
      settings: JSON.parse(serializedSettings),
      currency,
      locale,
      previewPrice: returnProtectionProductPrice,
    }

    if (!preview.unmount) {
      replacePreview(preview, containerRef.current, config)

      return
    }

    const timeout = setTimeout(replacePreview, previewUpdateDelay, preview, containerRef.current, config)

    return () => clearTimeout(timeout)
  }, [view, serializedSettings, currency, locale])

  useEffect(() => {
    const preview = previewRef.current

    return () => {
      const unmountPreview = preview.unmount

      preview.unmount = null
      queueMicrotask(() => unmountPreview?.())
    }
  }, [])

  return containerRef
}

export default useWidgetPreview
